var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgencyApp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "73.000000pt",
    height: "76.000000pt",
    viewBox: "0 0 73.000000 76.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "agency-app") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,76.000000) scale(0.100000,-0.100000)",
    fill: "#3b77d9",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 380 l0 -380 365 0 365 0 0 380 0 380 -365 0 -365 0 0 -380z m420 175 l50 -25 0 -60 0 -60 50 -25 51 -26 -3 -67 -3 -67 -52 -28 -52 -28 -51 26 -50 25 -50 -25 -51 -26 -52 28 -52 28 -3 67 -3 67 51 26 50 25 0 60 0 60 48 24 c59 31 62 31 122 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 541 l-35 -19 38 -18 c35 -17 39 -17 74 0 l38 18 -35 19 c-19 10 -37 18 -40 18 -3 0 -21 -8 -40 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270 455 c0 -42 2 -46 40 -65 l40 -20 0 48 c0 45 -2 49 -35 65 -20 9 -38 17 -40 17 -3 0 -5 -20 -5 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 483 c-30 -15 -33 -20 -33 -65 l0 -48 40 20 c38 19 40 23 40 65 0 50 -1 51 -47 28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220 371 l-35 -19 38 -18 c35 -17 39 -17 74 0 l38 18 -35 19 c-19 10 -37 18 -40 18 -3 0 -21 -8 -40 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420 371 l-35 -19 38 -18 c35 -17 39 -17 74 0 l38 18 -35 19 c-19 10 -37 18 -40 18 -3 0 -21 -8 -40 -18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170 285 c0 -42 2 -46 40 -65 l40 -20 0 48 c0 45 -2 49 -35 65 -20 9 -38 17 -40 17 -3 0 -5 -20 -5 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303 313 c-30 -15 -33 -20 -33 -65 l0 -48 40 20 c38 19 40 23 40 65 0 50 -1 51 -47 28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370 285 c0 -42 2 -46 40 -65 l40 -20 0 48 c0 45 -2 49 -35 65 -20 9 -38 17 -40 17 -3 0 -5 -20 -5 -45z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 313 c-30 -15 -33 -20 -33 -65 l0 -48 40 20 c38 19 40 23 40 65 0 50 -1 51 -47 28z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencyApp);
export default __webpack_public_path__ + "static/media/agency-app.eb9bbffd3bb51d2128bd20dbdfa7332f.svg";
export { ForwardRef as ReactComponent };